module.exports = __webpack_public_path__ + "static/sofiapro-regular-webfont-85f8cdea9906fa499535b29da11e1e31.woff2";